/**
 * Data access for the category entity (``GET /api/catalog/categories/?game=``).
 * Read-only; filtering is server-side.
 */
import { useApiQuery, type QueryState } from "@shared/api";

import type { Category } from "./model";

export const CATEGORIES_PATH = "/catalog/categories/";

/**
 * Fetch active categories, optionally scoped to a game. When ``gameId`` is
 * ``undefined`` the query is disabled (categories are only meaningful per game).
 */
export function useCategories(
  gameId: number | undefined,
): QueryState<readonly Category[]> {
  const enabled = gameId !== undefined;
  const path =
    gameId !== undefined
      ? `${CATEGORIES_PATH}?game=${gameId}`
      : CATEGORIES_PATH;
  return useApiQuery<readonly Category[]>(path, { enabled, deps: [gameId] });
}
